import type { INavigateOptions } from '../navigation';

// Omits the options arg entirely when none given — Next treats {} and no-arg differently internally.
export const callAppRouterNav = (
  navigate: (href: string, options?: { scroll?: boolean }) => void,
  href: string,
  options?: INavigateOptions,
): void => (options ? navigate(href, { scroll: options.scroll }) : navigate(href));
